var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKwendaMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.51 82.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.45,56.7a8.2,8.2,0,1,1-8.2,8.2A8.24,8.24,0,0,1,82.45,56.7ZM87.85,77a9,9,0,0,1,4.8.9c1,.5,8.1,5.8,8.1,5.8,2.6,1.8,10.5,12.5,10.5,12.5l-1.8,1.2,6.7,15.2,8.5-4a4.1,4.1,0,0,1,5.5,2.1l8.6,18.6a4.1,4.1,0,0,1-1.9,5.5l-2.4,1c0-.3.1-.6.1-.9a8.19,8.19,0,0,0-14.9-4.7l-14-30.2-1.2.8s-6.6-9.1-8.4-10.3c0,0-2-1.2-4.2-2.6.7,4.6,2.1,8.7,2.4,10.5,1.3,6.9.6,8.5-1.4,11.2s-8,12.2-8,12.2L77.75,139h-8.1l8-20.4,3.7-13.9-4.2-19.5a6,6,0,0,1,4.2-6.9l6.5-1.3ZM74.65,91.8,77,100l-8.6,4.4-3.7-7.3,8.7-4.5a5.67,5.67,0,0,0,1.3-.8Zm19.4,24.3,8.6,22.9h-8.2l-5.8-15.2,5.4-7.7Zm32.3,14.6a4.1,4.1,0,1,1-4.1,4.1A4.06,4.06,0,0,1,126.35,130.7Z",
    transform: "translate(-64.65 -56.7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKwendaMan);
export default __webpack_public_path__ + "static/media/kwenda-man.f8ef2c30216eb30ac8f45c95f88114b8.svg";
export { ForwardRef as ReactComponent };